import LegalDocumentPage from "@/components/LegalDocumentPage";

export default function TermsPage() {
  return <LegalDocumentPage docType="terms" testId="terms-page" />;
}
